import { useEffect, useState } from "react";
import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import FreshFeed from "./components/FreshFeed";
import CampusTopics from "./components/CampusTopics";
import Plaza from "./components/Plaza";
import Faq from "./components/Faq";
import About from "./components/About";
import SiteFooter from "./components/SiteFooter";
import { useReveal } from "@/hooks/useReveal";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-lift transition hover:bg-primary-600 ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  useReveal();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <TopNav />
      <main>
        <div className="reveal-on">
          <Hero />
        </div>
        <div className="reveal-on">
          <HotRank />
        </div>
        <div className="reveal-on">
          <FreshFeed />
        </div>
        <div className="reveal-on">
          <CampusTopics />
        </div>
        <div className="reveal-on">
          <Plaza />
        </div>
        <div className="reveal-on">
          <Faq />
        </div>
        <div className="reveal-on">
          <About />
        </div>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}